module.exports = __webpack_public_path__ + "static/media/3.1.4d35ac2e.png";